"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMenuItemTranslationFields = exports.getVendorTranslationFields = void 0;
const getVendorTranslationFields = (vendor) => {
    const { descriptionShort, descriptionFull, quote, metaTitle, metaDescription, sourcing } = vendor;
    return {
        descriptionShort,
        descriptionFull,
        quote,
        metaTitle,
        metaDescription,
        sourcing,
    };
};
exports.getVendorTranslationFields = getVendorTranslationFields;
const getMenuItemTranslationFields = (item) => {
    const { name, shortDescription, description } = item;
    return {
        name,
        shortDescription,
        description,
    };
};
exports.getMenuItemTranslationFields = getMenuItemTranslationFields;
